import { apiClient, toSignalError } from '@indipia/shared';
import type { SignalColor, SignalsResponse, TaskSignal, TodosResponse } from '@indipia/shared';
import type { ApiResponse } from '@indipia/shared-types';

// 공종 신호 조회 — GET /schedule/signals?siteId=&taskIds=&colors= (52-Planner, 신호_이후_구현지시서 4장).
// 응답: data.items[] = 공종별 신호 3줄(반장·발주·작업) + 대표색. 한글 문구는 서버가 만들지 않는다(@indipia/shared signalPresentation).
// 대상 공종의 신호가 하나라도 비면 서버가 503 SIGNAL_MISSING 을 돌려주고, 여기서 SignalMissingError 로 던진다 — 폴백 없음.

export interface GetSignalsOptions {
  /** 지정한 공종만 */
  taskIds?: number[];
  /** 해당 색의 신호가 있는 공종만 (RED·YELLOW 등) */
  colors?: SignalColor[];
  /** 요청 헤더(X-Comp-Id 등) */
  headers?: Record<string, string | undefined>;
}

export async function getSignals(siteId: number, opts: GetSignalsOptions = {}): Promise<TaskSignal[]> {
  const { taskIds, colors, headers } = opts;
  try {
    const res = await apiClient.get<ApiResponse<SignalsResponse>>('/schedule/signals', {
      params: {
        siteId,
        ...(taskIds && taskIds.length > 0 && { taskIds: taskIds.join(',') }),
        ...(colors && colors.length > 0 && { colors: colors.join(',') }),
      },
      headers,
    });
    return res.data.data?.items ?? [];
  } catch (e) {
    throw toSignalError(e);
  }
}

// 오늘 할일 조회 — GET /schedule/todos?scope=today&siteId=&memberId= (신호_이후_구현지시서 4장 2).
// 호출자(X-User-Id)가 현장 담당자(CHARGE·MANAGER)인 현장의 신호 중 할일 번호가 있는 빨강·노랑만 온다. week 는 서버가 400.
export interface GetTodosOptions {
  /** 한 현장만(생략하면 호출자의 모든 현장) */
  siteId?: number
  /** 요청 헤더(X-Comp-Id·X-User-Id 등) */
  headers?: Record<string, string | undefined>
}

export async function getTodayTodos(opts: GetTodosOptions = {}): Promise<TodosResponse> {
  try {
    const res = await apiClient.get<ApiResponse<TodosResponse>>('/schedule/todos', {
      params: { scope: 'today', ...(opts.siteId != null && { siteId: opts.siteId }) },
      headers: opts.headers,
    })
    return res.data.data
  } catch (e) {
    throw toSignalError(e)
  }
}
